import React, { useState, useRef, useEffect } from "react";
import { format, addDays, addWeeks, subWeeks, startOfWeek, endOfWeek } from "date-fns";
import { AgendaUser, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables } from "../../graphql/API";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useAuthContext } from "../../contexts/AuthContext";
import { Button, Spinner, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import { useTranslation} from "react-i18next";
import { enUS, fr } from 'date-fns/locale';
import Cookies from "js-cookie";
import { getAgendaUser, shiftsByComId } from "./queries";
import { Pagination } from '@aws-amplify/ui-react';
// import UserImage from "../../components/UserImage";
import Sidebar from "../services/Sidebar/Sidebar";
import useDateService from "../services/DateService";
import { SHIFTS_PER_PAGE } from "../../config";
import ShiftManager from "../../components/ShiftManager";
import { IShift } from "../../Types/models";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const AgendaManager: React.FC = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [shiftsState, setShiftsState] = useState([]);
  // DATE SERVICES
  const {getTIMEZONE, getMondayOfWeek, getNextMonday} = useDateService();
  // const [shiftsTotal, setShiftsTotal] = useState<{ hours: number, minutes: number }>({ hours: 0, minutes: 0 });
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // NAVIGATE
  const navigate = useNavigate();
  const location = useLocation();
  //WEEK VIEW CALENDAR
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const listRef = useRef<HTMLDivElement | null>(null);
  // Calendar
  const [showMonthCalendar, setShowMonthCalendar] = useState(false);
  // shifts
  const monday = getMondayOfWeek(new Date());
  const nextMonday = getNextMonday(new Date());

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser} = 
    useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
      {variables: {userId: AuthUserId}});

  const [fetchShifts, {data, loading, error, refetch, fetchMore}] = useLazyQuery
    <ShiftsByComIdQuery, ShiftsByComIdQueryVariables>
      (shiftsByComId);

  const user = dataUser?.getAgendaUser;

  // function getDateMinusDays(dateString: string, days: number) {
  //     const date = new Date(dateString);
  //     date.setDate(date.getDate() - days);
  //     return date.toISOString().split('T')[0]; // Format YYYY-MM-DD
  // }

  // function getDatePlusDays(dateString: string, days: number) {
  //     const date = new Date(dateString);
  //     date.setDate(date.getDate() + days);
  //     return date.toISOString().split('T')[0] + "T00:00:00.000Z"; // Format YYYY-MM-DD
  // }
  useEffect(() => {
    if (location.state && (location.state as any).refetchData) {
      refetch();
    }
  }, [location.state]);

  // const ITEMS_PER_PAGE = 25;

  const getShifts = async (token: string) => { //date: Date, 
    const monday = getMondayOfWeek(new Date(currentWeek)); //+"T05:00:00.000Z"
    const nextMonday = getNextMonday(new Date(currentWeek)); //+"T05:00:00.000Z"));

    // console.log('token', token);
    if (user?.comId) {
      return await fetchShifts({variables: {
        comId: user?.comId,
        startAt: {gt: monday},
        limit: SHIFTS_PER_PAGE,               
        nextToken: token,
        sortDirection: ModelSortDirection.ASC, //token ? ModelSortDirection.DESC : ModelSortDirection.ASC,
      filter: 
      {
        stopAt: {lt: nextMonday},
        suspended: {ne: true},
        deleted: {ne: true}
      }}});
    }
  }
  useEffect(() => {
    document.title = t('title.management');
  }, []);

  useEffect(() => {
      if (!user) return;
      if (!user.comId) return;
      if (!user.language) return;
      setLocale(user?.language);
      getShifts(pageTokens[pageTokens.length - 1]);
  }, [user]);

  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    getShifts(pageTokens[pageTokens.length - 1]);
  }, [currentWeek]);

  // PAGINATION
  useEffect(() => {
    if (data && data.shiftsByComId && !dontUpdateAnymore) {
      const newShifts = data.shiftsByComId.items;
      const newToken = data.shiftsByComId.nextToken;
  
      // console.log(newShifts);
      setShiftsState(newShifts);
      if (newToken) {
        setPageTokens((prevTokens) => [...prevTokens, newToken]); 
        setHasMorePages(true);
      } else {
        setHasMorePages(false); 
      }
    }
  }, [data]);

  useEffect(() => {
    setTotalPagination(pageTokens.length);
    // if (hasMorePages) {
    //   setTotalPagination(pageTokens.length);
    // } else {
    //   setTotalPagination(pageTokens.length - 1);
    // }
  },[hasMorePages]);

  const handlePageChange = async (pageIndex: any) => {
    setDontUpdateAnymore(true);
    setCurrentPageIndex(pageIndex);

    const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
    if (selectedToken !== undefined) {
      const { data: { shiftsByComId: { items: newShifts, nextToken: newNextToken } } } = await getShifts(selectedToken);
      // console.log('the', newShifts);
      if (newShifts.length !== 0) {
        setShiftsState(newShifts);
        setTotalPagination(pageTokens.length);
        // ITEMS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1)
        if (newNextToken && !pageTokens.includes(newNextToken)) {
          setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
        }
        // console.log(pageTokens);
      } else {
        if (hasMorePages) {
          // removeLastPagination();
          setHasMorePages(false);
        }
      }
    }
  };
  
  const handleNextPage = async () => {
    setDontUpdateAnymore(true);
    const nextToken = pageTokens[currentPageIndex];

    if (nextToken) {
      const { data: { shiftsByComId: { items: newShifts, nextToken: newNextToken } } } = await getShifts(nextToken);

      // console.log('next', newShifts);
      if (newNextToken) {
        setShiftsState(newShifts);
        setTotalPagination(pageTokens.length);
        if (!pageTokens.includes(newNextToken)) {
            setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
        }
        setCurrentPageIndex(currentPageIndex + 1);
      } else {
        if (newShifts.length > 0) {
          setShiftsState(newShifts);
          setTotalPagination(pageTokens.length);
          setCurrentPageIndex(currentPageIndex + 1);
          setHasMorePages(false);
        } else {
          if (hasMorePages) {
            setHasMorePages(false);
          }
        }
        // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
      }
      // console.log(pageTokens);

      // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
    } else {
      console.error("Next token is undefined or null");
    }
  };
  
  const handlePreviousPage = async () => {
    if (currentPageIndex > 1) {
      const prevToken = pageTokens[currentPageIndex - 2];

      const { data: { shiftsByComId: { items: prevShifts, nextToken: newNextToken } } } = await getShifts(prevToken);

      // console.log('prev', prevShifts);
      setShiftsState(prevShifts);
      if (hasMorePages) {
        setTotalPagination(pageTokens.length - 1);
      } else {
        setTotalPagination(pageTokens.length);
      }
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };
  
  const shifts = shiftsState;// data?.shiftsByComId?.items;

  if (loadingUser) {
    return (
      <div className="spinnerContainer">
          <Spinner animation="border" role="status" className="spinner">
              <span className="visually-hidden">Loading...</span>
          </Spinner>   
      </div>
    )
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }
  // WEEK VIEW CALENDAR

  // Calcule le début et la fin de la semaine actuelle
  const startWeek = startOfWeek(currentWeek, { weekStartsOn: 1, locale: getLanguage() });
  const endWeek = endOfWeek(currentWeek, { weekStartsOn: 1, locale: getLanguage() });

  // Navigation entre les semaines
  const nextWeek = () => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    setCurrentWeek(addWeeks(currentWeek, 1));
  };

  const prevWeek = () => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    setCurrentWeek(subWeeks(currentWeek, 1));
  }

  const fromMonthCalendar = (date: any) => {
    setPageTokens([null]);
    setTotalPagination(1);
    setCurrentPageIndex(1);
    setHasMorePages(true);
    setDontUpdateAnymore(false);
    setShiftsState([]);
    if (date instanceof Date) {
      setCurrentWeek(date); // ✅ Une seule date sélectionnée
    } else if (Array.isArray(date) && date[0] instanceof Date) {
      setCurrentWeek(date[0]); // ✅ Plage de dates : on prend le début
    }
  }

  const events = shifts ? shifts.map((shift) => ({
    shiftId: shift.shiftId,
    userId: shift.userId,
    username: shift.username,
    role: shift.role,
    info: shift.info,
    location: shift.location,
    startAt: shift.startAt,
    stopAt: shift.stopAt,
    accepted: shift.accepted,
    confirmed: shift.confirmed,
  })) : [];

  const matchShiftDate = (events: any[], fullDate: string ) => {
    // return events.some((shift) => format(new Date(shift.startAt), "yyyy-MM-dd", {locale: getLanguage()}) === fullDate);
    return events.some((shift) => {
      const startAt = new Date(shift.startAt);
      startAt.setHours(startAt.getHours() - TIMEZONE);
      return format(new Date(startAt), "yyyy-MM-dd", {locale: getLanguage()}) === fullDate;
    });
  };
  
  // Fonction pour faire défiler jusqu'à un jour spécifique
  const goToDate = (date: string) => {
    // console.log('date', date);
    const container = document.getElementById("shiftsContainer"); // Récupère l'élément qui doit scroller
    if (!container) return;

    const target = container.querySelector(`[data-date="${date}"]`);
    if (target) {
      container.scrollTo({
        top: (target as HTMLElement).offsetTop - (listRef.current as HTMLElement).offsetTop, // Assurer un bon alignement
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      {/* <style>
        {`
          html, body {
            overflow: hidden;
          }
        `}
      </style> */}
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3 pt-5">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="outline-primary" style={{alignSelf: "center"}} onClick={() => setShowMonthCalendar(!showMonthCalendar)}>
              {t('agenda.selectDate')}
            </Button>
          </div>
          <div className="scheduler-container">
            <div style={{ textAlign: "center" }}>
              {showMonthCalendar ? (
                <div className="my-3 d-flex justify-content-center">
                  <Calendar
                    onChange={(date) => {
                      setShowMonthCalendar(false); // Fermer le calendrier
                      fromMonthCalendar(date);
                      // if (date instanceof Date) {
                      //   setCurrentWeek(date); // ✅ Une seule date sélectionnée
                      // } else if (Array.isArray(date) && date[0] instanceof Date) {
                      //   setCurrentWeek(date[0]); // ✅ Plage de dates : on prend le début
                      // }
                    }}
                    value={currentWeek}
                    locale={savedLang || 'en'}
                    calendarType="iso8601"
                  />
                </div>
              ) : (
                <>
                  {/* Navigation des semaines */}
                  <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                    <div onClick={prevWeek} style={{ cursor: "pointer" }}><AiFillLeftCircle size={60} className="hover-icon"/></div>
                    <h2>{format(startWeek, "dd MMM", {locale: getLanguage()})} - {format(endWeek, "dd MMM yyyy", {locale: getLanguage()})}</h2>
                    <div onClick={nextWeek} style={{ cursor: "pointer" }}><AiFillRightCircle size={60} className="hover-icon"/></div>
                  </div>

                  {/* Liste des jours de la semaine */}
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "10px" }}>
                    {Array.from({ length: 7 }).map((_, i) => {
                      const dayFormatted = format(addDays(startWeek, i), "EEE", {locale: getLanguage()}); // Nom abrégé du jour (Mon, Tue, etc.)
                      let dateFormatted = format(addDays(startWeek, i), "d", {locale: getLanguage()}); // Numéro du jour du mois
                      const fullDate = format(addDays(startWeek, i), "yyyy-MM-dd", {locale: getLanguage()}); // Date complète au format ISO

                      return (
                        <div key={i} onClick={() => goToDate(fullDate)} style={{ cursor: "pointer", textAlign: "center" }}>
                          <div style={{ fontWeight: "bold" }}>{dayFormatted}</div>
                          <div className={`formattedDate ${matchShiftDate(events, fullDate) ? 'markedDate' : ''}`}
                          > {dateFormatted} </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            
              {/* Liste des événements scrollable */}
              <div
              style={{padding: 20}}
                id="shiftsContainer"
                ref={listRef}
              >
                <Stack direction="vertical" gap={3} >
                {events.length === 0 ? (
                  <div style={{ marginBottom: "10px" }}>
                    {t('agenda.noShift')}
                  </div>
                ) : (
                  events.map((shift, index) => {
                    return (
                      <ShiftManager 
                        // shift={item}
                        shift={{
                            ...shift,
                            user: (shift as any)?.user || null,
                        } as IShift}
                        lastStartAt={new Date(events[index === 0 ? 0 : index - 1].startAt)}
                        index={index}
                        locale={locale}
                        includedDetails={true}
                        // isNew={isNewShift(shift)}
                        user={user as AgendaUser}
                        nav={"AgendaManagement"}
                        // managers={managers as AgendaUser[]}
                    />
                    );
                  })
                )}
                </Stack>
              </div>
            </div>
            <div className="pagination-container">
              <h2 className="paginationTitle">{t('title.shifts')}</h2>
              <Pagination
                currentPage={currentPageIndex}
                totalPages={totalPagination}
                hasMorePages={hasMorePages}
                onNext={handleNextPage}
                onPrevious={handlePreviousPage}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgendaManager;